module.exports = __webpack_public_path__ + "static/media/bowen-41.3852e86c.jpg";